// THIS FILE IS AUTO GENERATED
var GenIcon = require('../lib').GenIcon;

module.exports.BiFootball = function BiFootball(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M19.071,4.929c-1.895-1.895-4.405-2.938-7.07-2.938c-2.666,0-5.177,1.044-7.072,2.938c-3.899,3.898-3.899,10.243,0,14.142 c1.895,1.895,4.406,2.938,7.073,2.938c2.666,0,5.176-1.043,7.07-2.937C22.971,15.174,22.971,8.829,19.071,4.929z M12.181,4h-0.359 c0.061-0.001,0.119-0.009,0.18-0.009S12.12,3.999,12.181,4z M18.243,17H16l-1.258,2.516c-0.868,0.318-1.791,0.493-2.741,0.493 c-0.952,0-1.876-0.175-2.746-0.494L8,17.01H5.765c-0.846-1.052-1.387-2.269-1.623-3.532L6,11L4.784,8.567 c0.381-0.804,0.895-1.56,1.559-2.224c0.919-0.92,2.021-1.584,3.22-1.969L12,6l2.438-1.625c1.198,0.385,2.301,1.049,3.22,1.968 c0.663,0.663,1.177,1.418,1.558,2.221L18,11l1.858,2.478C19.623,14.737,19.085,15.95,18.243,17z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8.5 11L10 15 14 15 15.5 11 12 8.5z"
      }
    }]
  })(props);
};